module.exports = __webpack_public_path__ + "static/media/clang.67214396.jpg";